import React from 'react'
import PropTypes from 'prop-types'
import { gql, useQuery } from '@apollo/client'

import { Select } from 'antd'

const TICKET_STATES_FOR_FILTER_QUERY = gql`
    query TicketStatesForFilter {
        ticketStatesForFilter {
            label
            value
        }
    }
`

const renderOptions = (options = []) => options.map(({ label, value }) => {
    return <Select.Option value={value}>{label}</Select.Option>
})

const TicketStatesForFilterSelector = ({ ...restProps }) => {
    const { loading, data } = useQuery(TICKET_STATES_FOR_FILTER_QUERY)

    return (
        <Select loading={loading} {...restProps}>
            {renderOptions(data && data.ticketStatesForFilter)}
        </Select>
    )
}

TicketStatesForFilterSelector.propTypes = {}

export default TicketStatesForFilterSelector
